export enum ProgressStepTypes {
  Finished = 'FINISHED',
  Waiting = 'WAITING',
  InProgress = 'IN_PROGRESS',
}
